import { ThemeUICSSObject } from '@apia/theme';
import execution from './execution';
import connectors from './connectors';
/* IMPORT HERE */
const ai: ThemeUICSSObject = {
  connectors,
  execution,
  /* PREPEND HERE */
};

export default ai;
